import React from "react";
import "./How_costomization_works.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare } from "@fortawesome/free-solid-svg-icons";

function How_costomization_works() {
  return (
    <>
      {/* <section className="How_costomization_works">
        <div className="custom_container">
          <div className="desktop_view_holder">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="How_costomization_works_design_hodler">
                  <div className="row justify-content-center">
                    <div className="col-md-8">
                      <div className="img_holder">
                        <img
                          src="/assest/luxury_images/gift_customisation/how_costomization_works/How_costomization_works.png"
                          alt="How costomization works"
                          className="How_costomization_works_img"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text_holder left_text_holder">
                    <h1>Upload Artwork:</h1>
                    <p>
                      Add an image or design of a product you wish to be
                      created.
                    </p>
                  </div>

                  <div className="text_holder center_text_holder">
                    <h1>Upload Artwork:</h1>
                    <p>
                      Add an image or design of a product you wish to be
                      created.
                    </p>
                  </div>

                  <div className="text_holder right_text_holder">
                    <h1>Upload Artwork:</h1>
                    <p>
                      Add an image or design of a product you wish to be
                      created.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mobile_view_holder">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="img_holder">
                  <img
                    src="/assest/luxury_images/gift_customisation/how_costomization_works/mobile_view_imgcostomizations.png"
                    alt="How costomization works"
                    className="How_costomization_works_img"
                  />
                </div>
              </div>
            </div>
            <div className="content_box_holder">
              <div className="text_holder ">
                <div className="number_holder">
                  <h1>01</h1>
                </div>
                <h1>Upload Artwork:</h1>
                <p>
                  Add an image or design of a product you wish to be created.
                </p>
              </div>

              <div className="text_holder ">
                <div className="number_holder">
                  <h1>02</h1>
                </div>
                <h1>Give Details</h1>
                <p>
                  Give us more details about your imagination in terms of
                  material, size, and expected price details.
                </p>
              </div>

              <div className="text_holder ">
                <div className="number_holder">
                  <h1>03</h1>
                </div>
                <h1>Enquire With Confidence</h1>
                <p>Submit your inquiry; our team will respond promptly.</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="How_costomization_works">
        <div className="custom_container">
          <h2 className="main_heading">How Customisation Works</h2>

          <div className="steps_container">
            <div className="step_card_holder">
              <div className="step_card">
                <div className="step_number">01</div>
                <h3>Choose Your Product</h3>
                <p>Select from our premium collection.</p>
              </div>
            </div>


            <div className="step_card_holder">
              <div className="step_card">
                <div className="step_number">02</div>
                <h3>Add Personalisation</h3>
                <p>Customise with a name, logo, or design.</p>
              </div>
            </div>


            <div className="step_card_holder">
              <div className="step_card">
                <div className="step_number">03</div>
                <h3>Get Your Gift</h3>
                <p>Receive your elegant, personalised product.</p>
              </div>
            </div>
          </div>

          <p className="bottom_text">Personalised Perfection, Step by Step</p>
        </div>
      </section>
    </>
  );
}

export default How_costomization_works;
